
// export const bankAccountData = () => {
    
//     const bbva1 = {
//         nombre: "BBVA",
//         convenio: "1 2 5 6 2 5"
//     }

//     return bbva1;
// }

export const account1 = {
    nombre: "BBVA",
    convenio: "0 0 2 2 7 6 7 1 2",
}